import { useMutation } from '@tanstack/react-query';
import InvitationService from '@/services/invitation.service';
import type { InvitationExchangeTokenInputPayload } from '@/types';

export const useTokenExchangeMutation = () => {
  return useMutation({
    mutationFn: (payload: InvitationExchangeTokenInputPayload) => InvitationService.exchangeToken(payload),
  });
};
